import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import IniciadorAsuntoForm from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/IniciadorAsuntoForm'
import IniciadorEjecucionForm from 'src/components/views/EscritosLexnet/components/IniciadorEjecucion/IniciadorEjecucionForm'
import PersonacionForm from 'src/components/views/EscritosLexnet/components/Personacion/PersonacionForm'
import VerificacionEnvioEscrito from 'src/components/views/EscritosLexnet/components/shared/components/VerificacionEnvioEscrito/VerificacionEnvioEscrito'
import { SHOW_FORM_ALWAYS } from 'src/config'
import { useEscritoContext } from 'src/contexts/EscritoContext/EscritoContext'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { TipoMensaje, TipoEscrito } from 'src/enums/EscritosLegales'
import MonitorioForm from './components/Monitorio/MonitorioForm'
import TramiteForm from './components/Tramite/TramiteForm'

export default function EscritosLexnetView(): JSX.Element {
  const { t } = useTranslation()
  const { tipoMensaje } = useTipoMensajeContext()
  const { escrito, send, setSend } = useEscritoContext()

  const getTipoMensaje = useCallback((): string => {
    const tipo = (escrito && escrito.tipoMensaje) || tipoMensaje
    switch (tipo) {
      case TipoMensaje.ESCRITO:
        return t('views.escritos_lexnet.tramite')
      case TipoMensaje.INICIADOR_ASUNTO:
        return t('views.escritos_lexnet.iniciador_asunto')
      case TipoMensaje.INICIADOR_EJECUCION:
        return t('views.escritos_lexnet.iniciador_ejecucion')
      case TipoMensaje.RECURSO_QUEJA:
        return t('views.escritos_lexnet.recurso_queja')
      case TipoMensaje.MONITORIO:
        return t('views.escritos_lexnet.monitorio')
      case TipoMensaje.INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME:
        return t('views.escritos_lexnet.recurso_sentencia_firme')
      case TipoMensaje.PERSONACION:
        return t('views.escritos_lexnet.personacion')
      default:
        return ''
    }
    // eslint-disable-next-line
  }, [tipoMensaje, escrito])

  const getSubsection = useCallback((): string => {
    const action = (escrito && escrito.id) > 0 ? 'Editar' : 'Nuevo'
    let type = ''

    if (escrito && escrito.tipo && escrito.tipo.id === TipoEscrito.BORRADOR) {
      type = '<i>BORRADOR</i>'
    }

    return `${action} ${type} ${getTipoMensaje()}`
    // eslint-disable-next-line
  }, [escrito])

  /* const getSection = useCallback((): string => {
    if (!escrito) return getTipoMensaje()

    if (escrito.descripcion) {
      return escrito.descripcion
    }

    return getTipoMensaje()
    // eslint-disable-next-line
  }, [escrito, getTipoMensaje]) */

  const renderTipoEscritoForm = useCallback(() => {
    const section: string = getSubsection()

    switch (tipoMensaje) {
      case TipoMensaje.ESCRITO:
        return <TramiteForm section={section} />
      case TipoMensaje.MONITORIO:
        return <MonitorioForm section={section} />
      case TipoMensaje.INICIADOR_ASUNTO:
        return <IniciadorAsuntoForm section={section} />
      case TipoMensaje.INICIADOR_EJECUCION:
        return <IniciadorEjecucionForm section={section} />
      case TipoMensaje.PERSONACION:
        return <PersonacionForm section={section} />
      default:
        return <TramiteForm section={section} />
    }
    // eslint-disable-next-line
  }, [tipoMensaje])

  useEffect(() => {
    if (!escrito?.idAcuseLexnet) {
      setSend(false)
    }
  }, [escrito?.idAcuseLexnet, setSend])

  return (
    <div>
      {/* <Breadcrumb section={getSubsection()} /> */}
      {(!send || SHOW_FORM_ALWAYS) && renderTipoEscritoForm()}
      {send && <VerificacionEnvioEscrito sended={send} idAcuseLexnet={escrito?.idAcuseLexnet} />}
    </div>
  )
}
